import {marked} from "marked";
import DOMPurify from "dompurify";
import {compute, create} from "@targoninc/jess";
import hljs from "highlight.js";
import {codeCopyButton} from "./code-copy-button.ts";
import {currentPage, nextAndPrev} from "../lib/state.ts";

function parseMarkdown(text: string) {
    const rawMdParsed = marked.parse(text, {
        async: false
    });
    return DOMPurify.sanitize(rawMdParsed as string);
}

function attachCodeCopyButtons() {
    const preCodes = document.querySelectorAll("pre code");
    for (const codeBlock of preCodes) {
        const pre = codeBlock.parentElement;
        if (!pre) continue;
        pre.classList.add("relative");
        pre.classList.add("hljs");
        if (!pre.querySelector(".code-copy-button")) {
            pre.appendChild(codeCopyButton(codeBlock.textContent || ""));
        }
    }
}

export function docsSite(content: string) {
    setTimeout(() => {
        hljs.highlightAll();
        document.querySelectorAll("article a:not([target='_blank'])").forEach(a => {
            const link = a as HTMLAnchorElement;
            link.target = "_blank";
            link.onclick = e => {
                if (e.button === 0 && (link.href.includes("localhost") || link.href.includes(window.location.host))) {
                    e.preventDefault();
                    const path = link.href.split(window.location.origin + "/")[1];
                    if (!path) {
                        currentPage.value = "index.md";
                    } else {
                        currentPage.value = path + ".md";
                    }
                }
            };
        });
        attachCodeCopyButtons();
    });

    return create("div")
        .classes("content-wrapper", "flex-v")
        .children(
            create("article")
                .classes("content", "relative")
                .children(
                    create("div")
                        .classes("content-scroll")
                        .children(
                            create("div")
                                .html(parseMarkdown(content))
                                .build()
                        ).build(),
                    create("div")
                        .classes("pagination-buttons", "flex", "space-between")
                        .children(
                            compute(np =>
                                    create("button")
                                        .classes("pagination-button")
                                        .text(`← Previous: ${np.prev?.title || ""}`)
                                        .onclick(() => {
                                            if (np.prev) currentPage.value = np.prev.filename;
                                        })
                                        .build()
                                , nextAndPrev),
                            compute(np =>
                                    create("button")
                                        .classes("pagination-button")
                                        .text(`Next: ${np.next?.title || ""} →`)
                                        .onclick(() => {
                                            if (np.next) currentPage.value = np.next.filename;
                                        })
                                        .build()
                                , nextAndPrev)
                        )
                )
        ).build();
}